
const Preguntas = [

    { id: 1, imagen: './img/1b.jpg', text: 'En escala de 1 a 5, ¿cuánto te angustia la suciedad?' },
    { id: 2, imagen: './img/2b.jpg', text: '¿Del 1 al 5 cuánto te angustia ver esta imagen?' },
    { id: 3, imagen: './img/3b.jpg', text: '¿Cuánto te cuesta salir de tu casa sin dejar todo en orden?' },
    { id: 4, imagen: './img/4b.jpg', text: '¿Qué nivel de obsesión tienes? ¿Necesitas dejar todo perfecto?' },
    { id: 5, imagen: './img/5b.jpg', text: 'En escala de 1 a 5, ¿Qué grado de control tienes sobre las conductas compulsivas?' },
    { id: 99, imagen: './img/portada.jpg', text: 'En escala de 1 a 5, ¿cuánto te angustia la suciedad?' },
];
export default Preguntas;